import { cdnTemplate } from 'cdnPreprocessor';

export default [
  function campaignUpsell() {
    return {
      restrict: 'E',
      scope: {
        shippingCountry: '@',
        campaignId: '@',
        originalCampaignId: '@',
        paymentMethod: '@',
        orderId: '@'
      },
      bindToController: true,
      controller: 'UpsellCtrl',
      controllerAs: 'upsell',
      templateUrl: cdnTemplate('/upsell.html'),
      link: (scope, el, attrs, ctrl) => {
        let initUpsellModal = () => {
          ctrl.init(scope.upsell.campaignId, scope.upsell.shippingCountry)
            .then(() => scope.upsellOpen = true);
        }

        scope.upsell.closeUpsell = () => {
          scope.upsellOpen = false;
          scope.upsell.stopCountdown();
          initUpsellModal();
        };

        initUpsellModal();
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/upsell/upsell.dir.js